export default __webpack_public_path__ + "media/images/brighteon-social/tutorial/Brighteon-Social-New-Post-bbf8cf951806cea0e0c463e302baadf9.png";